import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { ITributaryInformation } from "../../../../app/models/company";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import SelectMultipleInput from "../../../../app/common/form/SelectMultipleInput";
import SelectInput from "../../../../app/common/form/SelectInput";

const TributaryInformation = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { updateSupplierBillingInfo, supplier, btTributarySupplier } = rootStore.companyStore;
  const { partyTax, taxLevelCode } = rootStore.listOfValours;

  const [tributaryForm] = useState<ITributaryInformation>({
    partyTax: supplier?.partyTax || "",
    taxLevelCode: supplier?.taxLevelCode || [],
  });

  const handleFinalFormSubmit = (values: ITributaryInformation) => {
    if (
      tributaryForm.partyTax !== values.partyTax ||
      tributaryForm.taxLevelCode !== values.taxLevelCode 
    ) {
      if (values.partyTax.length < 1 || values.taxLevelCode.length < 1)
        toast.error("Todos los campos son obligatorios");
      else updateSupplierBillingInfo(values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="tabContentStyle">
      <FinalForm
        initialValues={tributaryForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Tributos</label>
              <Field
                name="partyTax"
                component={SelectInput}
                defaultValue={tributaryForm.partyTax}
                options={partyTax}
              />
              <label>Responsabilidades fiscales</label>
              <Field
                name="taxLevelCode"
                component={SelectMultipleInput}
                defaultValue={tributaryForm.taxLevelCode}
                options={taxLevelCode}
              />
              <br />
              <Button
                loading={btTributarySupplier}
                disabled={btTributarySupplier}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(TributaryInformation);
